/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddUserRoleRequest
 */
export interface AddUserRoleRequest {
    /**
     * 
     * @type {any}
     * @memberof AddUserRoleRequest
     */
    roleId?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AddUserRoleRequest
     */
    organizationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddUserRoleRequest
     */
    notifyUserByEmail?: boolean;
}

/**
 * Check if a given object implements the AddUserRoleRequest interface.
 */
export function instanceOfAddUserRoleRequest(value: object): value is AddUserRoleRequest {
    return true;
}

export function AddUserRoleRequestFromJSON(json: any): AddUserRoleRequest {
    return AddUserRoleRequestFromJSONTyped(json, false);
}

export function AddUserRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUserRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
        'notifyUserByEmail': json['notifyUserByEmail'] == null ? undefined : json['notifyUserByEmail'],
    };
}

export function AddUserRoleRequestToJSON(json: any): AddUserRoleRequest {
    return AddUserRoleRequestToJSONTyped(json, false);
}

export function AddUserRoleRequestToJSONTyped(value?: AddUserRoleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'organizationId': value['organizationId'],
        'notifyUserByEmail': value['notifyUserByEmail'],
    };
}

